// Vendors
import React from 'react';
import { FormattedMessage } from 'react-intl';
// Components
import { EmptyStatusComponent } from '@openbank/ziniaweb-ui-components';
// Constants
import { PAYMENT_ERROR_COMPONENT_PROPS } from './constants/payment-error.constants';
// Hooks
import { usePaymentErrorHook } from './hooks/payment-error.hook';
// Styles
import { PaymentErrorComponentStyled } from './payment-error.component.styled';
// Translations
import { DESCRIPTION, TITLE } from './translations/payment-error.translations';

const PaymentErrorComponent = (): React.JSX.Element => {
  usePaymentErrorHook();
  return (
    <PaymentErrorComponentStyled>
      <EmptyStatusComponent
        {...PAYMENT_ERROR_COMPONENT_PROPS}
        description={<FormattedMessage id={DESCRIPTION} />}
        title={<FormattedMessage id={TITLE} />}
      />
    </PaymentErrorComponentStyled>
  );
};

export { PaymentErrorComponent };
